import React, { useEffect, useRef, useState } from 'react'
import FilterItemsList from './FilterItemsList'
import { isNoItemsAvailable } from '../../domain/filterOptions/useCases/isNoItemsAvailable'
import { isNoSearchResults } from '../../domain/filterOptions/useCases/isNoSearchResults'
import {
  SearchInput,
  NoItemsAvailableMessage,
  NoSearchResultsMessage
} from './FilterTopbar'
import SearchAutocompleteLoading from '../Search/SearchAutocompleteLoading'

const FilterDropdown = ({
  setPopperElement,
  popperAttributes,
  label,
  toggleProps,
  selectedItems,
  refine,
  searchable,
  searchQuery,
  setSearchQuery,
  searchForItems,
  items,
  getItemProps,
  onSelectionChange,
  multiSelect,
  formatCount,
  topBarRef,
  clearFilters,
  popperStyles,
  taxonomy
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const noItemsAvailable = isNoItemsAvailable(searchable, searchQuery, items)
  const noSearchResults = isNoSearchResults(items, searchQuery)
  const thereAreItemsAvailableAndNoSearchResults =
    !noItemsAvailable && noSearchResults
  const thereAreItemsAvailableAndSearchResults =
    !noItemsAvailable && !noSearchResults

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      setIsLoading(false)
    }, 500)
    return () => clearTimeout(delayDebounceFn)
  }, [items])

  return (
    <div
      className="z-50"
      ref={setPopperElement}
      {...popperAttributes.popper}
      style={popperStyles}
    >
      <div
        className="pointer pointer-events-auto flex max-h-[528px] 
                      min-h-[200px] w-[300px] flex-col rounded-2xl border border-gray-300 bg-white shadow-lg"
      >
        {searchable && (
          <SearchInput
            label={label}
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            searchForItems={searchForItems}
            setIsLoading={setIsLoading}
          />
        )}
        {isLoading ? (
          <SearchAutocompleteLoading className={'m-auto'} />
        ) : (
          <>
            {noItemsAvailable && <NoItemsAvailableMessage label={label} />}
            {thereAreItemsAvailableAndNoSearchResults && (
              <NoSearchResultsMessage
                searchQuery={searchQuery}
                label={label}
              />
            )}
            {thereAreItemsAvailableAndSearchResults && (
              <FilterItemsList
                taxonomy={taxonomy}
                items={items}
                searchQuery={searchQuery}
                selectedItems={selectedItems}
                getItemProps={getItemProps}
                onSelectionChange={onSelectionChange}
                refine={refine}
                toggleProps={toggleProps}
                multiSelect={multiSelect}
                formatCount={formatCount}
                topBarRef={topBarRef}
                clearFilters={clearFilters}
              />
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default FilterDropdown
